var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.615 1H8.38526C6.41566 1.01089 4.53108 1.80374 3.14609 3.20416C1.7611 4.60459 0.989161 6.49785 1.00012 8.46743V17.5326C0.989161 19.5021 1.7611 21.3954 3.14609 22.7958C4.53108 24.1962 6.41566 24.9892 8.38526 25H17.615C19.5846 24.9892 21.4691 24.1962 22.8541 22.7958C24.2392 21.3954 25.011 19.5021 25.0002 17.5326V8.46743C25.011 6.49785 24.2392 4.60459 22.8541 3.20416C21.4691 1.80374 19.5846 1.01089 17.615 1Z",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1729 10.4785H19.9089V16.1957",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9086 10.4785L12.7086 17.8842C12.0781 18.5144 11.0696 18.5561 10.3892 17.9802L8.84636 16.6688C8.48665 16.3631 8.01686 16.2193 7.54773 16.2713C7.0786 16.323 6.65162 16.5661 6.36746 16.9431C6.30061 17.0322 6.23546 17.1231 6.16004 17.2054L2.17261 21.5717",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardactive);
export default __webpack_public_path__ + "static/media/dashboardactive.924193b136e7cb0b9e898ea3ea063fa5.svg";
export { ForwardRef as ReactComponent };